import common from "../../../utils/common";
import c from "../../../utils/constants";

class userVouchesController {
  constructor() {
    "ngInject"

  }

  $onInit() {

    this.gridOptions = {
      dataSource: this.vouches,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No Vouches."
      },
      columns: [
        // { field: "firstName", title: "First Name", filterable: false, width: "6rem" },
        // { field: "lastName", title: "Last Name", filterable: false, width: "6rem" },
        { field: "fullName", title: "Name", filterable: false, width: "4rem" },
        { field: "referenceType", title: "Type", filterable: false, width: "4rem", template: (dataItem) => `${this._getVouchReferenceType(dataItem.referenceType, dataItem.otherReferenceType)}` },
        { field: "email", title: "Email", filterable: false, width: "6rem" },
        { field: "phoneNumber", title: "Phone Number", filterable: false, width: "4rem" },
        { field: "whatWouldYouLikeToSay", title: "Feedback", filterable: false, width: "12rem" },
        // { field: "status", title: "Status", filterable: false, width: "4rem", template: (dataItem) => `${this._getVouchStatus(dataItem.status)}` },
        // { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: `#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #` },
        // { field: "approvalDate", title: "Approval Date", filterable: false, width: "4rem", template: `#= approvalDate ? kendo.toString(new Date(approvalDate), 'dd-MM-yyyy') : '-' #` },
        // { field: "cancellationDate", title: "Cancellation Date", filterable: false, width: "4rem", template: `#= cancellationDate ? kendo.toString(new Date(cancellationDate), 'dd-MM-yyyy') : '-' #` },
        // { field: "vouchKey", title: "Vouch URL", filterable: false, width: "8rem", template: `<a target="_blank" href="#='https://www.jugglestreet.com/vouch?key=' + vouchKey#">Link</a>` },
      ]
    }
  }

  _getVouchReferenceType(status, otherReferenceType) {
    switch(status) {
      case c.vouchReferenceType.FAMILY:
        return "Family";
      case c.vouchReferenceType.CHILDCAREEMPLOYMENT:
        return "Childcare Employment";
      case c.vouchReferenceType.NONCHILDCAREEMPLOYMENT:
        return "Non-childcare Employment";
      case c.vouchReferenceType.OTHER:
        return "Other (" + otherReferenceType + ")";
      case c.vouchReferenceType.JUGGLESTREET:
        return "Juggle Street";
        case c.vouchReferenceType.UNSPECIFIED:
          return "-";
    }
  }

  _getVouchStatus(status) {
    switch(status) {
      case c.vouchStatus.PENDING:
        return "Follow-up";
      case c.vouchStatus.APPROVED:
        return "Complete";
      case c.vouchStatus.CANCELLED:
        return "Incomplete";
        case c.vouchStatus.EXPIRED:
          return "Expired";
      case c.vouchStatus.NONE:
        return "-";
    }
  }

}

export default userVouchesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-vouches/user-vouches.controller.js
 **/